module.exports = __webpack_public_path__ + "static/media/Alert.839e2d5b.svg";